'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlTag = require('graphql-tag');

var graphql = graphqlTag.gql`
  query Maptiler {
    maptiler {
      key
    }
  }
`;

exports["default"] = graphql;
